import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

export interface monthlyReport {
    firstName: string;
    lastName: string;
    picture: string;
    summary: any;
    userName: string;
}

const initialState: monthlyReport[] = [];

const monthlyReportReducer = createSlice({
    name: 'monthlyReport',
    initialState: initialState,
    reducers: {
        setMonthlyReportReducer: (state, action: AnyAction) => {

            return action.payload;
        },
        updateMonthlyReportReducer: (state, action) => {

            const indexOfMonthlyReportToChange = state.findIndex(report => report.userName === action.payload.userName);
            const changedMonthlyReport = action.payload;

            state[indexOfMonthlyReportToChange] = changedMonthlyReport;
            return state;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(revertAll, () => initialState);
    }
});

export const { setMonthlyReportReducer, updateMonthlyReportReducer } = monthlyReportReducer.actions;

export default monthlyReportReducer;